/* DERMOXEL MEN'S COLLAGEN — isolated page script (no globals except none). */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.dxReady) return;
    root.dataset.dxReady = '1';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* Gallery */
    var mainBtn = $('.dermoxel-gallery__main');
    var mainImg = mainBtn ? mainBtn.querySelector('img') : null;
    var count = $('[data-dx-count]');
    var thumbs = $$('[data-dx-thumb]');
    if (count) count.textContent = '1 / ' + (thumbs.length || 1);
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = t.dataset.dxSrc;
        if (t.dataset.dxSrcset) mainImg.srcset = t.dataset.dxSrcset;
        mainImg.alt = t.dataset.dxAlt || '';
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
        if (count) count.textContent = (i + 1) + ' / ' + thumbs.length;
      });
    });

    /* Lightbox */
    var lb = $('[data-dx-lightbox]');
    var lbImg = $('[data-dx-lightbox-img]');
    if (mainBtn && lb && lbImg && typeof lb.showModal === 'function') {
      mainBtn.addEventListener('click', function () {
        lbImg.src = mainImg.currentSrc || mainImg.src;
        lbImg.alt = mainImg.alt;
        lb.showModal();
      });
      $('[data-dx-close]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    }

    /* Offers */
    var variantInput = $('[data-dx-variant]');
    var form = $('[data-dx-form]');
    var radios = $$('[data-dx-offers] input[type="radio"]');
    function setText(sel, val) { $$(sel).forEach(function (el) { el.textContent = val; }); }
    function apply(radio, silent) {
      var price = radio.dataset.dxPrice;
      var title = radio.dataset.dxTitle;
      var ship = radio.dataset.dxShip;
      $$('.dermoxel-offer').forEach(function (l) { l.classList.toggle('is-selected', l.contains(radio)); });
      setText('[data-dx-sum-offer]', title);
      setText('[data-dx-sum-ship]', ship);
      setText('[data-dx-sum-price]', price);
      setText('[data-dx-hero-price]', price);
      setText('[data-dx-hero-offer]', title + ' · التوصيل ' + ship);
      setText('[data-dx-btn-price]', price);
      setText('[data-dx-sticky-price]', price);
      setText('[data-dx-sticky-offer]', title);
      if (variantInput && variantInput.value !== radio.value) {
        variantInput.value = radio.value;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (!silent) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: Number(radio.value) } } }));
      }
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) apply(r); });
    });
    var checked = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    if (checked) apply(checked, true);

    /* Smooth jump to the order box */
    var order = $('[data-dx-order]');
    $$('[data-dx-goto]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!order) return;
        e.preventDefault();
        order.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var first = order.querySelector('input:not([type="hidden"]):not([type="radio"]), select, textarea');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 450);
      });
    });

    /* Sticky CTA: visible after the hero, hidden while the order box is on screen */
    var sticky = $('[data-dx-sticky]');
    var hero = $('.dermoxel-hero');
    if (sticky && hero && order) {
      var btn = sticky.querySelector('a');
      var update = function () {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var h = hero.getBoundingClientRect();
        var o = order.getBoundingClientRect();
        var heroGone = h.bottom < 0;
        var orderOnScreen = o.top < vh && o.bottom > 0;
        var show = heroGone && !orderOnScreen;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (btn) btn.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-dermoxel]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
